import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { prepareAuthenticatedHeaders } from './utils/headers'
import type { SponsorshipType } from '../types'

export const sponsorshipApi = createApi({
  reducerPath: 'sponsorshipApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API_URL}/api/v1/sponsorship-types`,
    prepareHeaders: prepareAuthenticatedHeaders,
  }),
  tagTypes: ['Sponsorship'],
  endpoints: builder => ({
    listSponsorshipsType: builder.query<SponsorshipType[], void>({
      query: () => ({
        url: '/',
      }),
    }),
    mySponsorship: builder.query<SponsorshipType, void>({
      query: () => ({
        url: '/my-sponsorship/',
      }),
    }),
  }),
})

export const { useMySponsorshipQuery } = sponsorshipApi
